import React, { useRef, useState, useEffect } from "react";
import { ArrowDownRight, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheCreativeVision() {
  const {
    ref: headlineRef,
    isVisible: isHeadlineVisible
  } = useRevealOnScroll();
  const {
    ref: bioRef,
    isVisible: isBioVisible
  } = useRevealOnScroll();
  const buttonRef = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState({
    x: 0,
    y: 0
  });
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!buttonRef.current) return;
    const {
      left,
      top,
      width,
      height
    } = buttonRef.current.getBoundingClientRect();
    const x = e.clientX - (left + width / 2);
    const y = e.clientY - (top + height / 2);
    const xMove = x * 0.2;
    const yMove = y * 0.2;
    setPosition({
      x: xMove,
      y: yMove
    });
  };
  const handleMouseLeave = () => {
    setPosition({
      x: 0,
      y: 0
    });
  };
  return <section data-section-id="9735" id="our-expertise" className="dark bg-[#0a1120] text-foreground relative w-full min-h-screen flex flex-col lg:flex-row overflow-hidden">
      {}
      <div className="relative w-full min-h-[60vh] flex flex-col justify-between p-6 border-r border-white/5 !bg-[url(https://climbing-leech-1.10web.cloud/wp-content/uploads/2026/03/Gemini_Generated_Image_5fvtgk5fvtgk5fvt.png)] !bg-[url(https://climbing-leech-1.10web.cloud/wp-content/uploads/2026/03/Gemini_Generated_Image_1o455s1o455s1o45-1.png)] !bg-[url(https://climbing-leech-1.10web.cloud/wp-content/uploads/2026/03/Gemini_Generated_Image_hpz0dhpz0dhpz0dh.png)] !opacity-[1] lg:w-[60%] lg:min-h-screen lg:p-12">
        {}
        

        {}
        

        {}
        <div className="relative z-20 mt-12 lg:mt-0 lg:absolute lg:bottom-12 lg:left-12">
          <div ref={buttonRef} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} style={{
          transform: `translate(${position.x}px, ${position.y}px)`,
          transition: "transform 0.1s ease-out"
        }} className="inline-block">
            <Link to="/ServicesPage" className="block group">
              
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="relative w-full lg:w-[40%] bg-white flex flex-col justify-center p-8 lg:p-20 border-t lg:border-t-0 lg:border-l border-slate-100">
        <div ref={bioRef} className={`max-w-md mx-auto lg:mx-0 transition-all duration-1000 delay-300 ease-out transform ${isBioVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="mb-8">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-sm bg-slate-50 border border-slate-200 text-xs font-mono text-[#0a1120]/70 uppercase tracking-widest">
              <span className="w-1.5 h-1.5 rounded-full bg-[#00938a] animate-pulse" />
              Senior Experts Only
            </span>
          </div>

          <h2 className="font-sans text-2xl md:text-3xl lg:text-4xl font-bold leading-tight mb-8">
            <span className="bg-gradient-to-br from-[#0a1120] via-[#0a1120]/90 to-[#00938a] bg-clip-text text-transparent">Own Your Projects. Deliver on Time and on Budget. 
          </span>
          </h2>

          <p className="font-sans text-slate-500 text-lg leading-relaxed mb-12">Projectora delivers end-to-end project and programme 
management as a managed service. 

We define deliverables upfront, structure payments 
around milestones, and hand over cleanly at close.

No agency finder's fees. No onboarding delays. 
No idle billing. Just delivery.</p>

          <div className="flex flex-wrap gap-4">
            <Button variant="outline" className="rounded-sm px-8 py-6 border-[#0a1120] bg-[#0a1120] text-white hover:bg-[#00938a] hover:border-[#00938a] hover:text-white transition-all duration-300 text-base font-bold" asChild>
              <Link to="/ContactPage" className="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive border shadow-xs h-9 has-[>svg]:px-3 rounded-sm px-8 py-6 border-[#0a1120] text-white transition-all duration-300 text-base font-bold inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive border shadow-xs h-9 has-[>svg]:px-3 rounded-sm px-8 py-6 border-[#0a1120] text-white transition-all duration-300 text-base font-bold !bg-[hsl(196,64%,24%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 dark:bg-input/30 dark:border-input dark:hover:bg-input/50 hover:bg-[#00938a] hover:border-[#00938a] hover:text-white disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 dark:bg-input/30 dark:border-input dark:hover:bg-input/50 hover:bg-[#00938a] hover:border-[#00938a] hover:text-white">
                Consult With Us
              </Link>
            </Button>
            <Button variant="ghost" className="rounded-sm px-8 py-6 hover:bg-slate-50 text-base font-semibold text-[#0a1120]" asChild>
              <Link to="/DeliverablesPage" className="inline-flex items-center justify-center gap-2 whitespace-nowrap transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive h-9 has-[>svg]:px-3 rounded-sm px-8 py-6 text-base font-semibold inline-flex items-center justify-center gap-2 whitespace-nowrap transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive h-9 has-[>svg]:px-3 rounded-sm px-8 py-6 text-base font-semibold inline-flex items-center justify-center gap-2 whitespace-nowrap transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive h-9 has-[>svg]:px-3 rounded-sm px-8 py-6 text-base font-semibold inline-flex items-center justify-center gap-2 whitespace-nowrap transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive h-9 has-[>svg]:px-3 rounded-sm px-8 py-6 text-base font-semibold !bg-[hsl(196,64%,24%)] !text-[hsl(0,0%,100%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:text-accent-foreground dark:hover:bg-accent/50 hover:bg-slate-50 disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:text-accent-foreground dark:hover:bg-accent/50 hover:bg-slate-50 disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:text-accent-foreground dark:hover:bg-accent/50 hover:bg-slate-50 disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:text-accent-foreground dark:hover:bg-accent/50 hover:bg-slate-50">Our Deliverables</Link>
            </Button>
          </div>

          {}
          <div className="mt-24 pt-8 border-t border-slate-100 flex justify-between items-end text-xs font-mono text-slate-400">
            <div>
              
              
            </div>
            <div className="text-right">
              <p>PRECISION IN MOTION</p>
              
            </div>
          </div>
        </div>
      </div>
    </section>;
}